// @flow
export type Endpoints = {
  product: string,
  pet: string,
  map: string,
  partner: Url,
}

function getEndpoints(env: ?string): Endpoints {
  if (!env) {
    throw new Error('No process.env.NODE_ENV found.')
  }

  switch (env) {
    case 'test':
    case 'development':
      return {
        product: 'https://product-test.mumupetguide.com',
        pet: 'https://pet-test.mumupetguide.com',
        map: 'https://service-provider-test.mumupetguide.com',
        partner: 'https://partner-service-test.mumupetguide.com/partner/goodbyeitch',
      }
    case 'production':
      return {
        product: 'https://product-test.mumupetguide.com',
        pet: 'https://pet-test.mumupetguide.com',
        map: 'https://service-provider-test.mumupetguide.com',
        partner: 'https://partner-service-test.mumupetguide.com/partner/goodbyeitch',
        // product: 'https://product.mumupetguide.com',
        // pet: 'https://pet.mumupetguide.com',
        // map: 'https://service-provider.mumupetguide.com/',
        // partner: 'https://partner-service.mumupetguide.com/partner/goodbyeitch',
      }
    default: throw new Error(`Unknown environment: ${env}; support only "developement" and "production"`)
  }
}

export const endpoints: Endpoints = getEndpoints(process.env.NODE_ENV)
